import React from "react";
import { ClipboardList } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NotYetRecordedMember } from "../../features/billing/models/NotYetRecordedMember";

interface NotYetRecordedListProps {
  members: NotYetRecordedMember[];
  memberName: (memberId: string) => string;
  /** Opens the new-pack flow for this member, so the visits get covered. */
  onNewPack: (memberId: string) => void;
}

/** Members whose recent visits exceed their remaining pack capacity, with a one-click fix. */
const NotYetRecordedList: React.FC<NotYetRecordedListProps> = ({
  members,
  memberName,
  onNewPack,
}) => {
  const { t } = useTranslation();
  if (members.length === 0) return null;

  return (
    <div className="mt-8">
      <h3 className="flex items-center gap-2">
        <ClipboardList size={20} className="text-grey-30 dark:text-grey-70" />
        {t("billing.notYetRecorded.title")}
      </h3>
      <p className="mt-1 text-sm text-grey-40 dark:text-grey-80">
        {t("billing.notYetRecorded.description")}
      </p>
      <ul className="mt-3 space-y-2">
        {members.map((m) => (
          <li
            key={m.memberId}
            className="flex flex-wrap items-center justify-between gap-3 rounded-md border border-grey-90 dark:border-primary-20 bg-white dark:bg-primary-10 p-3 text-sm text-grey-20 dark:text-white"
          >
            <span>
              {t("billing.notYetRecorded.line", {
                member: memberName(m.memberId),
                visits: m.recentVisitCount,
                remaining: m.remainingCapacity,
              })}
            </span>
            <button type="button" className="btn btn-secondary" onClick={() => onNewPack(m.memberId)}>
              {t("billing.actions.newPack")}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NotYetRecordedList;
